import { DownloadTargetActionTypes } from "../constants/ApiConstants";


const initialState = {
    loading: false,
    uploadCSVDocumentsForDCMessage: null,
    uploadBehaviorData: null,
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DownloadTargetActionTypes.post_UploadNewTargets.REQUEST:
            return {
                ...state,
                loading: true,
                uploadCSVDocumentsForDCMessage: null,
               
            };
        case DownloadTargetActionTypes.post_UploadNewTargets.SUCCESS:
            return {
                ...state,
                loading: false,
                uploadCSVDocumentsForDCMessage: payload,
            };
        case DownloadTargetActionTypes.post_UploadNewBehaviors.REQUEST:
            return {
                ...state,
                loading: true,
                uploadBehaviorData: null,
               
            };
        case DownloadTargetActionTypes.post_UploadNewBehaviors.SUCCESS:
            return {
                ...state,
                loading: false,
                uploadBehaviorData: payload,
            };
        default:
            return state
        }
    }


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargets/reducers/downloadTargetReducer.js